import { GalleryState } from 'editor/src/store/gallery/types';

const resetSessionImageReducer = (state: GalleryState) => {
  state.sessionImages = [];
};

export default resetSessionImageReducer;
